import "./fetch.js";
import "./main.js";
import "./atproto.js";


//Scroll To An item
scrollToElement = function (targetElement) {
   scrollDistance = targetElement.offset();
   document.querySelector('html').scrollTop(scrollDistance.top - 0);
};
